export function lowComplexity(rules) {
    return { primaryRules: [rules.CharLength]};
}

export function mediumComplexity(rules) {
    const mediumComplexityRules = {
        primaryRules: [
            rules.CharLength,
            rules.NoUserIdentity
        ],
        characterTypeRules: [
            rules.UppercaseChars,
            rules.LowercaseChars,
            rules.NumberChars
        ]
    };

    return mediumComplexityRules;
}

export function strongComplexity(rules) {
    const strongComplexityRules = {
        primaryRules: [
            rules.CharLength,
            rules.NoUserIdentity
        ],
        characterTypeRules: [
            rules.UppercaseChars,
            rules.LowercaseChars,
            rules.NumberChars,
            rules.SymbolChars
        ]
    };

    return strongComplexityRules;
}
